
import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getRules, getBaseInfo } from '../api';
import { Toast } from 'vant';
import qs from 'qs';

@Component
export default class Rule extends Vue {
  content = '';
  baseInfo: any = {};
  async created() {
    const unionId = window.localStorage.getItem('unionid');
    if (!unionId && isWeiXin()) {
      this.WechatLogin();
    }
    const ret = await getRules();
    this.content = ret.data;
    const ret111 = await getBaseInfo();
    this.baseInfo = ret111.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
}
